module.exports = __webpack_public_path__ + "img/poster_bg_4.75eb3d75.png";